import React, { useState, useEffect, useCallback, useContext } from 'react';
import NouvelleSession from './NouvelleSession';
import SessionSelector from './SessionSelector';
import Session from '../phases/Session';
import { useNavigate, useLocation } from 'react-router-dom';
import {ReactComponent as PicLogo} from '../icon.svg';
import { LoadingContext } from '../App'; // NOUVEAU : Import du contexte de chargement

const Main = ({ 
  user, 
  setUser, 
  joinSession, 
  setJoinSession, 
  creatingSession, 
  setCreatingSession, 
  isAdmin, 
  setIsAdmin, 
  setModalContent, 
  setModalTitle, 
  setShowModal,
  currentPhase,
  setCurrentPhase,
  setGoNext,
  setCloseSession,
  onEndSessionChange
}) => {
  const [derniereMaj, setDerniereMaj] = useState(new Date());
  const [motDePasse, setMotDePasse] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  
  // NOUVEAU : Utiliser le contexte de chargement
  const isInitializing = useContext(LoadingContext);

  const handleCreateSession = () => {
    navigate('/nouvellesession/');
  };

  const handleJoinSession = () => {
    navigate('/listesessions/');
  };

  const handleEndSessionChange = useCallback((endSession) => {
    if (onEndSessionChange) {
      onEndSessionChange(endSession);
    }
  }, [onEndSessionChange]);

  // 🛡️ PROTECTION MINIMALE - Nettoyage uniquement en cas de vraie incohérence
  useEffect(() => {
    // Seulement nettoyer si on est sur l'accueil ET qu'on a une session fantôme
    // ET qu'on n'est pas en train de naviguer ET qu'on n'est pas en initialisation
    if (location.pathname === '/' && user.currentsession && !creatingSession && !joinSession && !isInitializing) {
      console.log('[Main] Nettoyage session fantôme sur accueil');
      setUser(prev => ({ 
        ...prev, 
        currentsession: null,
        isready: false 
      }));
    }
  }, [location.pathname, user.currentsession, creatingSession, joinSession, setUser, isInitializing]);

  // 🔒 VALIDATION DE L'ÉTAT AVANT RENDU
  const hasValidSession = user.currentsession && 
                         user.currentsession !== "" && 
                         user.currentsession !== null && 
                         user.currentsession !== undefined;

  const isOnSessionRoute = location.pathname.includes('/session/');

  // NOUVEAU : Si on est en train d'initialiser et qu'on essaie d'accéder à une session
  // Afficher un écran de chargement minimal
  if (isInitializing) {
    // Si on est sur une route de session, afficher un écran vide ou un loader minimal
    if (isOnSessionRoute) {
      return <></>; // chargement de la session
    }
    // Pour les autres routes pendant l'initialisation, ne rien afficher
    return null;
  }

  // Si l'utilisateur est dans une session ET on est sur la bonne route
  if (hasValidSession && isOnSessionRoute) {
    return (
      <Session 
        user={user} 
        setUser={setUser}  
        derniereMaj={derniereMaj} 
        setDerniereMaj={setDerniereMaj} 
        isAdmin={isAdmin} 
        setIsAdmin={setIsAdmin} 
        motDePasse={motDePasse} 
        setMotDePasse={setMotDePasse}
        setModalContent={setModalContent}
        setModalTitle={setModalTitle}
        setShowModal={setShowModal}
        currentPhase={currentPhase}
        setCurrentPhase={setCurrentPhase}
        setGoNext={setGoNext}
        setCloseSession={setCloseSession}
        onEndSessionChange={handleEndSessionChange}
      />
    );
  }

  // Si on crée une session
  if (creatingSession) {
    return (
      <NouvelleSession 
        user={user} 
        setUser={setUser} 
        derniereMaj={derniereMaj} 
        setDerniereMaj={setDerniereMaj} 
        setMotDePasse={setMotDePasse}
        setModalContent={setModalContent}
        setModalTitle={setModalTitle}
        setShowModal={setShowModal}
      />
    );
  }

  // Si on rejoint une session
  if (joinSession) {
    return (
      <SessionSelector 
        user={user} 
        setUser={setUser}  
        derniereMaj={derniereMaj} 
        setDerniereMaj={setDerniereMaj}
      />
    );
  }

  // 🏠 ÉCRAN D'ACCUEIL
  return (
    <div className="home-screen-new fade-in">
      <div className="home-header">
        <div className="app-emoji">
          <PicLogo className="app-logo" />
        </div>
        <div className="app-title-text">
          <h1 className="app-title">Collab</h1>
          <p className="app-subtitle">Rédigez et réfléchissez de façon collaborative</p>
        </div>
      </div>
      
      <div className="home-actions-new">
        <div className="action-tile" onClick={handleCreateSession}>
          <div className="tile-icon">
            <svg className="action-svg" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="5" fill="none"/>
              <path d="M35 50h30M50 35v30" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="tile-content">
            <h3 className="tile-title">Commencer une session</h3>
            <p className="tile-description">Créez une nouvelle session collaborative et invitez des participants</p>
          </div>
        </div>

        <div className="action-tile" onClick={handleJoinSession}>
          <div className="tile-icon">
            <svg className="action-svg" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 20 L 45 50 L 15 80" stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M55 20 L 85 50 L 55 80" stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="tile-content">
            <h3 className="tile-title">Rejoindre une session</h3>
            <p className="tile-description">Participez à une session existante en cours ou consultez les archives</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;